"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'OtherParamsForm',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      paramsList: [],
      // 参数列表
      addParamDialogVisible: false,
      // 添加参数对话框显示状态
      isInternalUpdate: false,
      // 标记是否为内部更新，避免循环
      newParam: {
        // 新参数对象
        attrName: '',
        attrValue: '',
        showList: false,
        showTitle: false
      },
      paramRules: {
        attrName: [{
          required: true,
          message: '请输入参数名称',
          trigger: 'blur'
        }, {
          max: 50,
          message: '参数名称不能超过50个字符',
          trigger: 'blur'
        }],
        attrValue: [{
          required: true,
          message: '请输入参数值',
          trigger: 'blur'
        }, {
          max: 100,
          message: '参数值不能超过100个字符',
          trigger: 'blur'
        }]
      },
      // 用于酒店类型参数的存储
      attrValue: []
    };
  },
  watch: {
    value: {
      handler: function handler(val) {
        // 避免无限循环：如果是内部更新触发的，则忽略
        if (this.isInternalUpdate) {
          this.isInternalUpdate = false;
          return;
        }
        // 只有当外部传入值时才更新内部数据
        if (val && Array.isArray(val)) {
          this.paramsList = JSON.parse(JSON.stringify(val));
        }
      },
      immediate: true
    },
    paramsList: {
      handler: function handler(val) {
        // 标记为内部更新，避免触发value的watch
        this.isInternalUpdate = true;
        this.$emit('input', val);
      },
      deep: true
    }
  },
  methods: {
    // 显示添加参数对话框
    showAddParamDialog: function showAddParamDialog() {
      var _this = this;
      this.newParam = {
        attrName: '',
        attrValue: '',
        showList: false,
        showTitle: false
      };
      this.addParamDialogVisible = true;
      this.$nextTick(function () {
        _this.$refs.paramForm && _this.$refs.paramForm.clearValidate();
      });
    },
    // 添加参数
    handleAddParam: function handleAddParam() {
      var _this2 = this;
      this.$refs.paramForm.validate(function (valid) {
        if (valid) {
          // 检查是否有重复的参数名
          var isDuplicate = _this2.paramsList.some(function (item) {
            return item.attrName === _this2.newParam.attrName;
          });
          if (isDuplicate) {
            _this2.$message.warning('参数名已存在，请使用其他名称');
            return;
          }

          // 添加新参数
          _this2.paramsList.push({
            attrName: _this2.newParam.attrName,
            attrValue: _this2.newParam.attrValue,
            showList: _this2.newParam.showList,
            showTitle: _this2.newParam.showTitle
          });
          _this2.$message.success('添加参数成功');
          _this2.addParamDialogVisible = false;
        }
      });
    },
    // 删除参数
    handleDeleteParam: function handleDeleteParam(index) {
      var _this3 = this;
      this.$confirm('确定要删除此参数吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.paramsList.splice(index, 1);
        _this3.$message.success('删除成功');
      }).catch(function () {});
    },
    // 获取表单数据
    getFormData: function getFormData() {
      return this.paramsList;
    },
    // 表单验证（商品参数无必填项）
    validate: function () {
      var _validate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              return _context.a(2, Promise.resolve(true));
          }
        }, _callee);
      }));
      function validate() {
        return _validate.apply(this, arguments);
      }
      return validate;
    }()
  }
};